module.exports = __webpack_public_path__ + "static/media/Capture.b9282f49.JPG";